import { apiFetch } from "./client";

export async function fetchServices() {
  return apiFetch("/api/services");
}

export async function createService(payload) {
  return apiFetch("/api/services", {
    method: "POST",
    body: payload,
  });
}

export async function updateService(serviceId, payload) {
  return apiFetch(`/api/services/${serviceId}`, {
    method: "PUT",
    body: payload,
  });
}

export async function deleteService(serviceId) {
  return apiFetch(`/api/services/${serviceId}`, {
    method: "DELETE",
  });
}